import React from 'react';
import { connect } from 'react-redux';
import { firstError } from '@/utils/errors';
import findResult from '@/utils/resultsHelper';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { showSaveSearch } from '../actions';

const SaveSearchAction = ({
  code,
  category,
  isNew,
  readErrors,
  saveSearch,
}) => (
  <RibbonMenu
    name="save"
    icon="save"
    message="actions.save"
    onClick={() => saveSearch(category, code, isNew)}
    className="aridhia-save-search-action"
    disabled={firstError(readErrors) !== null}
  />
);

const mapStateToProps = ({
  search: { searches },
}, { category, code }) => {
  const search = findResult(searches, category, code);

  return {
    isNew: search ? search.isNew : true,
    readErrors: search ? search.readErrors : [],
  };
};

const mapDispatchToProps = {
  saveSearch: showSaveSearch,
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveSearchAction);
